import { BaseClient } from '@/api'
import request from '@/utils/request'

export class DriverClient extends BaseClient {
  constructor(
  ) {
    super('drivers')
  }

  async leave(id: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}/leave/accept`,
      method: 'put'
    })
  }
}
